import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { CommunicationDirectionsTypeService } from './communciation-direction-type.service';
import { CommunicationDirectionType } from './communication-direction-type.interface';
const service = new CommunicationDirectionsTypeService();

export interface CommunicationDirectionTypeState {
   communicationDirectionTypes: Array<CommunicationDirectionType>;
}

const CommunicationDirectionTypeStore: Module<CommunicationDirectionTypeState, StoreState> = {
   namespaced: true,
   state: { communicationDirectionTypes: [] },
   getters: { communicationDirectionTypes: (state) => state.communicationDirectionTypes },
   mutations: {
      SET_COMMUNICATION_DIRECTION_TYPES(state, communicationDirectionTypes: Array<CommunicationDirectionType>) {
         state.communicationDirectionTypes = communicationDirectionTypes;
      },
   },
   actions: {
      async getCommunicationDirectionTypes(context, query: LocationQuery) {
         const response = await service.getCommunicationDirectionsTypes({ ...query, per_page: '9999', page: '1' });
         context.commit('SET_COMMUNICATION_DIRECTION_TYPES', response.data);
         return response;
      },
   },
};

export default CommunicationDirectionTypeStore;
